import { Button, Select, TextInput } from "@wearewqa/wqa-design-system";
import React, { ChangeEvent, FormEvent, useState } from "react";
import { Modal } from "../components/Modal/Modal";
import { createApp } from "../resources/apps";
import { Heading } from "../components/Heading";
import { countryCodes } from "../utilities";

type CreateAppModalProps = {
  isOpen: boolean;
  onClose: () => void;
};

type CreateAppFormData = {
  name: string;
  country_code: string;
};

export const CreateAppModal = ({ isOpen, onClose }: CreateAppModalProps) => {
  const [formData, setFormData] = useState<CreateAppFormData>({
    name: "",
    country_code: "",
  });

  function onInputChange(key: string, value: string) {
    setFormData((prevState) => ({ ...prevState, [key]: value }));
  }

  async function manageFormSubmit(event: FormEvent<HTMLFormElement>) {
    event.preventDefault();

    try {
      const app = await createApp(formData);
      if (app) {
        console.log(`Success. App '${app.name}' has been created.`);
        window.location.reload();
      }
    } catch (error) {
      console.error("AdminAppForm - ManageFormSubmit: ", error);
    }
  }

  return (
    <Modal {...{ isOpen, onClose }}>
      <div className="create-app-modal">
        <Heading type="h2" label="Create a new App." />
        <br />
        <form className="modal-form" onSubmit={(e) => void manageFormSubmit(e)}>
          <TextInput
            required
            id={"app_form__name"}
            label={"App Name"}
            onChange={(event: ChangeEvent<HTMLInputElement>) =>
              onInputChange("name", event.target.value)
            }
          />

          <div className="modal-form__store-inputs">
            <Select
              required
              id={"app_form__country"}
              label={"Select an counrty."}
              options={countryCodes}
              value={formData.country_code}
              onChange={(e) => onInputChange("country_code", e)}
            />
          </div>

          <Button label={"Submit"} type="submit" />
        </form>
      </div>
    </Modal>
  );
};
